<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div class="academy-addedit-wrap">
    <div class="preview">
      <div class="header">预览</div>
      <div class="phone">
        <img
          :src="previewInfo.roleImg"
          class="banner"
          @click="editFlag = 1"
          :class="[editFlag == 1 ? 'hasBorder' : '']"
        />
        <div class="news">
          <div class="header">资讯</div>
          <ul
            v-if="previewInfo.informationList.length > 0"
            @click="editFlag = 2"
            class="newsBox"
            :class="[editFlag == 2 ? 'hasBorder' : '']"
          >
            <li
              v-for="(item, index) in previewInfo.informationList"
              class="informationList"
              :key="index"
            >
              <img :src="item.picUrl" alt />
              <div class="infoBox">
                <div class="title">{{ item.title }}</div>
                <div class="author">{{ item.author }}</div>
              </div>
            </li>
          </ul>
          <div
            v-else
            style="min-height:340px;font-size:18px;line-height:340px;"
            class="newsBox"
            @click="editFlag = 2"
            :class="[editFlag == 2 ? 'hasBorder' : '']"
          >
            点击添加资讯
          </div>
        </div>
      </div>
      <el-button type="primary" class="save" @click="save">保存专区</el-button>
    </div>
    <div class="edit">
      <div v-if="editFlag == 1">
        <div class="header">第一步：选择封面图</div>
        <el-upload
          class="uploadImg"
          drag
          action="/rest/cso/saas/upload/image"
          :on-success="uploadDone"
          :show-file-list="false"
        >
          <!-- <i class="el-icon-upload"></i> -->
          <img
            v-if="previewInfo.roleImg"
            :src="previewInfo.roleImg"
            class="avatar"
          />
          <div class="el-upload__text">
            <el-button type="primary" class="reLoad">重新上传</el-button>
            <br />
            请上传16:9图片
          </div>
          <!-- <div class="el-upload__tip" slot="tip">请上传16:9图片</div> -->
        </el-upload>
        <div class="header">第二步：选择跳转内容</div>
        <div class="top">
          <img
            src="http://cdn.yxvzb.com/WEB/sass/img/newsLabel.png"
            class="label"
          />
          <el-input
            type="text"
            placeholder="请输入关键字"
            v-model="searchQuery.title"
            clearable
          ></el-input>
          <el-button type="primary" @click="searchEvent">搜索</el-button>
        </div>
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          @current-change="handleCurrentChange1"
          border
          class="bannerTable"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column
            property="title"
            align="center"
            label="资讯"
            :show-overflow-tooltip="true"
            style="text-align:center;"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="createDt"
            label="资讯创建时间"
          >
            <template slot-scope="scope">
              {{ scope.row.createDt }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="author"
            label="作者"
          >
            <template slot-scope="scope">
              {{ scope.row.author || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="relationStatus"
            label="关联状态"
          >
            <template slot-scope="scope">
              {{ !scope.row.relationStatus ? '未关联' : '已关联' }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="80" label="选择">
            <template slot-scope="scope">
              <img
                src="http://cdn.yxvzb.com/WEB/sass/img/selected.png"
                v-if="scope.row.id == previewInfo.informationId"
                class="selectImg"
              />
              <img
                src="http://cdn.yxvzb.com/WEB/sass/img/unSelect.png"
                v-else
                class="selectImg"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
      <div v-else-if="editFlag == 2">
        <div class="header">添加资讯</div>
        <div class="top">
          <img
            src="http://cdn.yxvzb.com/WEB/sass/img/newsLabel.png"
            class="label"
          />
          <el-input
            type="text"
            placeholder="请输入资讯标题"
            v-model="searchQuery.title"
            clearable
          ></el-input>
          <el-button type="primary" @click="searchEvent">搜索</el-button>
        </div>
        <el-table
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          border
          class="bannerTable"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          ></el-table-column>
          <el-table-column
            property="title"
            label="资讯"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="createDt"
            label="资讯创建时间"
          >
            <template slot-scope="scope">
              {{ scope.row.createDt }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="author"
            label="作者"
          >
            <template slot-scope="scope">
              {{ scope.row.author || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="relationStatus"
            label="关联状态"
          >
            <template slot-scope="scope">
              {{ !scope.row.relationStatus ? '未关联' : '已关联' }}
            </template>
          </el-table-column>
          <el-table-column label="选择" width="80" align="center">
            <template slot-scope="scope">
              <img
                src="http://cdn.yxvzb.com/WEB/sass/img/muliti.png"
                v-if="scope.row.status"
                @click="select(scope.row, 0)"
                class="selectImg"
              />
              <img
                src="http://cdn.yxvzb.com/WEB/sass/img/unMuliti.png"
                v-else
                class="selectImg"
                @click="select(scope.row, 1)"
              />
            </template>
          </el-table-column>
          <el-table-column label="权重">
            <template slot-scope="scope">
              <input
                v-if="scope.row.status"
                type="number"
                v-model="scope.row.weight"
                @blur="changeWeight(scope.row)"
                style="width:56px;"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="保存专区"
      :visible.sync="dialogTableVisible"
      width="420px"
    >
      <el-input
        v-model="previewInfo.title"
        autocomplete="off"
        placeholder="请输入专区名称"
        style="width:300px;height:40px;"
        :maxlength="22"
      >
        <span slot="suffix" style="line-height:40px">
          {{ previewInfo.title.length }}/22
        </span>
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="finalSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { btLoading } from '@/Mixin/btLoading';
import { pageInation } from '@/Mixin/listMixin2';
import { dbCon } from '@/Mixin/doubleConfirm';
import { channel } from '@/api/ajax';
export default {
  mixins: [btLoading, dbCon, pageInation],
  data() {
    return {
      editFlag: 1, //右边编辑的类型 1是banner 2是资讯
      previewInfo: {
        roleImg: 'https://cdn1.yxvzb.com/staticPage/1561441545672.png', //banner地址
        informationId: '', //关联banner的资讯id
        title: '', //标题
        informationList: [],
        id: ''
      },
      dialogTableVisible: false,
      // tableData:[{text:'脑仁大新闻',id:1,isSelect:false},{text:'脑仁大新闻1',id:2,isSelect:true},{text:'脑仁大新闻2',id:3,isSelect:false}],
      currentRow: null,
      radio: '',
      getList: channel.picUrlInformation,
      searchQuery: {
        title: '',
        id: ''
      },
      tempInfoList: [] //临时资讯列表
    };
  },
  components: {},
  methods: {
    getParams(url) {
      try {
        // var index = url.indexOf('?');
        url = url.match(/\?([^#]+)/)[1];
        var obj = {},
          arr = url.split('&');
        for (var i = 0; i < arr.length; i++) {
          var subArr = arr[i].split('=');
          var key = decodeURIComponent(subArr[0]);
          var value = decodeURIComponent(subArr[1]);
          obj[key] = value;
        }
        return obj;
      } catch (err) {
        return null;
      }
    },
    repro(path, obj) {
      let i,
        url = '';
      for (i in obj) {
        url += '&' + i + '=' + obj[i];
      }
      return path + url.replace(/./, '?');
    },
    shareCallbackFunc(url, arg1 = 'shareTimes') {
      let obj = this.getParams(url);
      if (!obj[arg1]) {
        //如果第一次分享
        return `${url}&${arg1}=1`;
      } else {
        obj[arg1] = 1 + Number(obj[arg1]);
        return this.repro(url.split('?')[0], obj);
      }
    },
    check(row) {
      //检查是否被选中
      if (row.status == 1) {
        return true;
      } else {
        for (let item of this.tempInfoList) {
          if (item.id == row.id) {
            row = item;
            return true;
          }
        }
      }
    },
    changeWeight(row) {
      for (let item of this.tempInfoList) {
        if (item.id == row.id) {
          item.weight = row.weight;
        }
      }
    },
    del(target) {
      this.tempInfoList.forEach((item, index) => {
        if (item.informationId == target.id) {
          this.tempInfoList.splice(index, 1);
        }
      });
    },
    select(row, boll) {
      row.status = boll;
      if (boll) {
        //添加
        row.status = 1;
        this.tempInfoList.push({
          informationId: row.id,
          weight: Number(row.weight),
          ...row
        });
      } else {
        //删除
        row.status = 0;
        this.del(row);
      }
    },
    uploadDone(response) {
      //上传banner
      this.previewInfo.roleImg = response.data;
    },
    finalSave() {
      //提交接口保存专区
      if (!this.previewInfo.title) {
        this.$message({
          messgae: '请填写专区名称',
          type: 'warning'
        });
      } else {
        channel.addUpdateChannel(this.previewInfo).then(() => {
          history.go(-1);
        });
      }
    },
    save() {
      //保存专区
      if (!this.previewInfo.roleImg) {
        this.$message({
          message: '请上传专区banner',
          type: 'warning'
        });
      } else if (!this.previewInfo.informationId) {
        this.$message({
          message: '请为banner关联资讯',
          type: 'warning'
        });
      } else if (this.previewInfo.informationList.length == 0) {
        this.$message({
          message: '请为专区关联资讯',
          type: 'warning'
        });
      } else {
        this.dialogTableVisible = true;
      }
    },
    handleCurrentChange1(val) {
      if (val) {
        this.currentRow = val;
        this.previewInfo.informationId = val.id;
      }
    }
    // submitForm(formName, type) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       // 改变按钮状态
    //       // 混合对象 格式化数据
    //       let data = Object.assign({}, this.ruleForm);
    //       data.price = moneyComplete(data.price);
    //       data.type = type;
    //       project.addUpdateOtcProject(data).then(res => {
    //         this.$notify({
    //           title: '成功',
    //           message: type === 0 ? '保存成功' : '提交成功',
    //           type: 'success'
    //         });
    //         this.resetForm();
    //       });
    //     } else {
    //       return false;
    //     }
    //   });
    // }
  },
  computed: {
    ifDisable() {
      return this.ruleForm.projectStatus ? true : false;
    },
    imgList() {
      return [
        {
          name: '',
          url: this.previewInfo.bannerUrl
        }
      ];
    }
  },
  watch: {
    editFlag(v) {
      if (v == 1) {
        this.getList = channel.picUrlInformation;
        this.getPageList();
      } else {
        this.getList = channel.channelInformationList;
        this.getPageList();
      }
    },
    tempInfoList: {
      deep: true,
      handler(v) {
        if (v.length > 1) {
          let temp;
          let tempArr = [...v];
          for (let i = 0; i < tempArr.length - 1; i++) {
            for (let j = tempArr.length - 1; j >= i + 1; j--) {
              if (tempArr[j].weight > tempArr[j - 1].weight) {
                temp = tempArr[j];
                tempArr[j] = tempArr[j - 1];
                tempArr[j - 1] = temp;
              }
            }
          }
          this.previewInfo.informationList = tempArr;
        } else {
          this.previewInfo.informationList = v;
        }
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.searchQuery.id = this.$route.query.id;
      channel
        .loadChannel({
          id: this.$route.query.id
        })
        .then(res => {
          let { channel, informationList } = res.data.data;
          for (let item of informationList) {
            item.status = 1;
          }
          this.tempInfoList = informationList;
          this.previewInfo = {
            roleImg: channel.roleImg, //banner地址
            informationId: channel.informationId, //关联banner的资讯id
            title: channel.title, //标题
            informationList: informationList,
            id: channel.id
          };
        });
    }
  }
};
</script>
<style lang="scss">
.bannerTable {
  width: 100%;
  thead tr .is-leaf {
    background: #a3d0fd;
  }

  th > .cell,
  td {
    text-align: center;
  }
}
</style>

<style lang="scss" scoped>
.academy-addedit-wrap {
  height: 100%;
  display: flex;
  padding-left: 35px;
  overflow-y: auto;
  width: 100%;

  .preview {
    // margin-right: 150px;

    .header {
      font-size: 18px;
      color: #333;
      text-align: left;
      margin-bottom: 52px;
    }

    .header:before {
      width: 4px;
      height: 20px;
      background: #1989fa;
      content: '';
      display: inline-block;
      margin-right: 10px;
      vertical-align: middle;
    }

    .hasBorder {
      border: 1px solid #1989fa;
    }

    .phone {
      width: 375px;
      border: 1px solid #000;
      margin-bottom: 33px;
      border-radius: 25px;
      padding: 17px;

      .banner {
        width: 100%;
        height: 210px;
        cursor: pointer;
      }

      .banner:hover {
        border: 1px solid #1989fa;
      }

      .news {
        // padding: 0 17px;
        min-height: 350px;

        .header {
          font-size: 12px;
          margin-bottom: 8px;
        }

        .newsBox {
          cursor: pointer;
          border: 1px solid transparent;
        }

        .newsBox:hover {
          border-color: #1989fa;
        }

        .header:before {
          width: 2px;
          height: 10px;
        }

        ul {
          background: #fff;
          min-height: 350px;
        }

        .informationList {
          padding: 14px 8px;
          display: flex;
          space-around: center;
          background: #f7fbff;
          margin-bottom: 10px;

          img {
            width: 66px;
            height: 59px;
            margin-right: 8px;
          }

          .infoBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }

          .title {
            font-size: 12px;
            color: #333;
            line-height: 18px;
            // margin-bottom:8px;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            width: 250px;
          }

          .author {
            font-size: 10px;
            color: #333;
            line-height: 15px;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            width: 250px;
          }
        }
      }
    }

    .save {
      // margin-left: 120px;
    }
  }

  .edit {
    padding-left: 30px;
    width: 60%;
    max-width: 700px;
    ::v-deep {
      .uploadImg {
        width: 100%;
        height: 270px;
        margin-bottom: 30px;
        .el-upload-dragger {
          width: 100%;
          height: 270px;
        }
      }
    }
    .header {
      font-size: 18px;
      color: #333;
      text-align: left;
      margin-bottom: 5px;
      color: #1989fa;
    }

    .header:before {
      width: 4px;
      height: 20px;
      background: #1989fa;
      content: '';
      display: inline-block;
      margin-right: 10px;
      vertical-align: middle;
    }

    .top {
      display: flex;
      margin-bottom: 10px;
      align-items: flex-end;
      justify-content: space-between;
      & > img {
        width: 117px;
        height: 37px;
      }

      .label {
        // margin-right: 15vw;
      }

      .el-input {
        margin-left: auto;
        margin-right: 20px;
        width: 160px;
      }
    }

    .uploadImg {
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      .el-upload__text {
        position: absolute;
        top: 90px;
        left: 50%;
        margin-left: -44px;
        // .reLoad{
        //   width:88px;
        //   height:40px;
        //   line-height:40px;
        //   font-size:14px;
        // }
      }
    }
  }
}
</style>
